
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Explore() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('الكل');
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [sortBy, setSortBy] = useState('الأحدث');

  const categories = ['الكل', 'خضروات', 'فواكه', 'ألبان', 'لحوم', 'مخبوزات', 'مشروبات'];
  const sortOptions = ['الأحدث', 'الأكثر مبيعاً', 'السعر: من الأقل للأعلى', 'السعر: من الأعلى للأقل', 'الأعلى تقييماً'];

  const products = [
    {
      id: 1,
      name: 'طماطم طازجة - كيلو',
      price: 12,
      oldPrice: 15,
      image: 'https://public.readdy.ai/ai/img_res/b43a248860b331947028690f35e470ea.jpg',
      rating: 4.8,
      sold: 1250,
      category: 'خضروات'
    },
    {
      id: 2,
      name: 'حليب طازج - لتر',
      price: 15,
      oldPrice: 18,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%20dairy%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20white%20and%20blue%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=expgro2&orientation=squarish',
      rating: 4.9,
      sold: 2100,
      category: 'ألبان'
    },
    {
      id: 3,
      name: 'خبز طازج',
      price: 8,
      oldPrice: 10,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20loaf%20bakery%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20golden%20brown%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=expgro3&orientation=squarish',
      rating: 4.7,
      sold: 890,
      category: 'مخبوزات'
    },
    {
      id: 4,
      name: 'تفاح أحمر - كيلو',
      price: 18,
      oldPrice: 22,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20apples%20fruit%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20bright%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=expgro4&orientation=squarish',
      rating: 4.9,
      sold: 650,
      category: 'فواكه'
    },
    {
      id: 5,
      name: 'دجاج طازج - كيلو',
      price: 35,
      oldPrice: 40,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20chicken%20meat%20poultry%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=expgro5&orientation=squarish',
      rating: 4.6,
      sold: 1500,
      category: 'لحوم'
    },
    {
      id: 6,
      name: 'عصير برتقال - لتر',
      price: 12,
      oldPrice: 15,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20juice%20bottle%20beverage%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20orange%20color%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=expgro6&orientation=squarish',
      rating: 4.8,
      sold: 980,
      category: 'مشروبات'
    }
  ];

  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-24" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3">
          <h2 className="text-xl font-bold text-gray-800 mb-3">استكشف المنتجات</h2>
          
          {/* Search Bar */}
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="ابحث عن منتجات البقالة..."
              className="w-full pr-12 pl-4 py-3 bg-gray-100 rounded-2xl text-sm border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
              <i className="ri-search-line text-xl text-gray-400"></i>
            </div>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center"
            >
              <i className="ri-equalizer-line text-white"></i>
            </button>
          </div>
        </div>

        {/* Categories */}
        <div className="px-4 pb-3 overflow-x-auto scrollbar-hide">
          <div className="flex gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Filters Panel */}
      {showFilters && (
        <div className="fixed inset-0 bg-black/50 z-50" onClick={() => setShowFilters(false)}>
          <div
            className="absolute bottom-0 w-full bg-white rounded-t-3xl p-6 max-h-[80vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-800">الفلاتر</h3>
              <button onClick={() => setShowFilters(false)} className="w-8 h-8 flex items-center justify-center">
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            {/* Sort By */}
            <div className="mb-6">
              <h4 className="text-sm font-bold text-gray-800 mb-3">ترتيب حسب</h4>
              <div className="space-y-2">
                {sortOptions.map((option) => (
                  <button
                    key={option}
                    onClick={() => setSortBy(option)}
                    className={`w-full px-4 py-3 rounded-xl text-right transition-all duration-300 ${
                      sortBy === option
                        ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white'
                        : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            {/* Price Range */}
            <div className="mb-6">
              <h4 className="text-sm font-bold text-gray-800 mb-3">نطاق السعر</h4>
              <div className="px-2">
                <input
                  type="range"
                  min="0"
                  max="2000"
                  value={priceRange[1]}
                  onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
                  style={{ opacity: 0, position: 'absolute' }}
                />
                <div className="relative h-2 bg-gray-200 rounded-lg">
                  <div
                    className="absolute h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg"
                    style={{ width: `${(priceRange[1] / 2000) * 100}%` }}
                  ></div>
                  <div
                    className="absolute w-5 h-5 bg-white border-2 border-blue-500 rounded-full -top-1.5 shadow-lg cursor-pointer"
                    style={{ right: `${100 - (priceRange[1] / 2000) * 100}%`, transform: 'translateX(50%)' }}
                  ></div>
                </div>
                <div className="flex justify-between mt-3 text-sm text-gray-600">
                  <span>{priceRange[0]} ر.س</span>
                  <span>{priceRange[1]} ر.س</span>
                </div>
              </div>
            </div>

            <button
              onClick={() => setShowFilters(false)}
              className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold shadow-lg"
            >
              تطبيق الفلاتر
            </button>
          </div>
        </div>
      )}

      {/* Products Grid */}
      <div className="pt-44 px-4">
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-gray-600">{products.length} منتج</p>
        </div>

        <div className="grid grid-cols-2 gap-4" data-product-shop>
          {products.map((product) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-2 left-2 px-2 py-1 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full">
                  -{Math.round(((product.oldPrice - product.price) / product.oldPrice) * 100)}%
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-gray-800 mb-1 line-clamp-2">{product.name}</h3>
                <div className="flex items-center gap-1 mb-2">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  <span className="text-xs font-bold text-gray-800">{product.rating}</span>
                  <span className="text-xs text-gray-400">({product.sold})</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {product.price} ر.س
                  </span>
                  <span className="text-xs text-gray-400 line-through">{product.oldPrice}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <Link to="/" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-home-line text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </Link>
          <button className="flex flex-col items-center justify-center gap-1 text-blue-600">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </button>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <Link to="/favorites" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-heart-line text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </Link>
          <Link to="/profile" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-user-line text-xl"></i>
            <span className="text-xs">حسابي</span>
          </Link>
        </div>
      </nav>
    </div>
  );
}
